import { DashboardDimension, TrendGranularity, DataType, TrendType } from './types';
export enum DEVICE_TYPE_MAP {
  GAS = 1,
  WATER = 2,
}

// ========== 废气配置 ==========
export const enum GasPropertyKey {
  noxEmission = 13700,
  nmhcEmission = 13702,
  exhaustVolume = 13695,
}

export const GAS_PROPERTY_MAP = {
  [GasPropertyKey.noxEmission]: '氮氧化物排放量',
  [GasPropertyKey.nmhcEmission]: '非甲烷总烃排放量',
  [GasPropertyKey.exhaustVolume]: '废气排放量',
};

export const GasArray = [
  {
    label: GAS_PROPERTY_MAP[GasPropertyKey.noxEmission],
    propertyId: GasPropertyKey.noxEmission,
  },
  {
    label: GAS_PROPERTY_MAP[GasPropertyKey.nmhcEmission],
    propertyId: GasPropertyKey.nmhcEmission,
  },
  {
    label: GAS_PROPERTY_MAP[GasPropertyKey.exhaustVolume],
    propertyId: GasPropertyKey.exhaustVolume,
  },
];

// ========== 废水配置 ==========

export const enum WaterPropertyKey {
  ammoniaNitrogenEmission = 13690,
  codEmission = 13691,
  totalNitrogenEmission = 13693,
  totalPhosphorusEmission = 13692,
  wastewaterVolume = 10437,
}

export const WATER_PROPERTY_MAP = {
  [WaterPropertyKey.wastewaterVolume]: '废水排放量',
  [WaterPropertyKey.codEmission]: 'COD排放量',
  [WaterPropertyKey.totalPhosphorusEmission]: '总磷排放量',
  [WaterPropertyKey.totalNitrogenEmission]: '总氮排放量',
  [WaterPropertyKey.ammoniaNitrogenEmission]: '氨氮排放量',
};

export const WaterArray = [
  {
    label: WATER_PROPERTY_MAP[WaterPropertyKey.wastewaterVolume],
    propertyId: WaterPropertyKey.wastewaterVolume,
  },
  {
    label: WATER_PROPERTY_MAP[WaterPropertyKey.codEmission],
    propertyId: WaterPropertyKey.codEmission,
  },
  {
    label: WATER_PROPERTY_MAP[WaterPropertyKey.totalPhosphorusEmission],
    propertyId: WaterPropertyKey.totalPhosphorusEmission,
  },
  {
    label: WATER_PROPERTY_MAP[WaterPropertyKey.totalNitrogenEmission],
    propertyId: WaterPropertyKey.totalNitrogenEmission,
  },
  {
    label: WATER_PROPERTY_MAP[WaterPropertyKey.ammoniaNitrogenEmission],
    propertyId: WaterPropertyKey.ammoniaNitrogenEmission,
  },
];

export type PropertyKey = GasPropertyKey | WaterPropertyKey;

// ==================== 维度常量 ====================
export const DIMENSION_OPTIONS: { value: DashboardDimension; label: string }[] = [
  { value: 'MONTH', label: '月' },
  { value: 'YEAR', label: '年' },
];

// ==================== 时间粒度常量 ====================
export const GRANULARITY_OPTIONS = [
  { value: TrendGranularity.HOUR, label: '按小时', maxRange: 6 },
  { value: TrendGranularity.DAY, label: '按日', maxRange: 30 },
  { value: TrendGranularity.MONTH, label: '按月', maxRange: 35 },
];

// ==================== 趋势类型常量 ====================
export const TREND_TYPE_OPTIONS: { value: TrendType; label: string }[] = [
  { value: 'VOCS', label: '整体VOCs' },
  { value: 'ACCUMULATION', label: '累积量' },
];

// ==================== 废气排放总览指标 ====================
export const GAS_OVERVIEW_INDICATORS = [
  { key: 'gasEmission', name: '废气排放量', unit: 'm³' },
  { key: 'nox', name: '氮氧化物排放量', unit: 'kg' },
  { key: 'nmhc', name: '非甲烷总烃排放量', unit: 'kg' },
];

// ==================== 废水排放总览指标 ====================
export const WATER_OVERVIEW_INDICATORS = [
  { key: 'nh3nEmission', name: '氨氮化物排放量', unit: 'kg' },
  { key: 'tpEmission', name: '总磷排放量', unit: 'kg' },
  { key: 'codEmission', name: 'COD排放量', unit: 'kg' },
  { key: 'tnEmission', name: '总氮排放量', unit: 'kg' },
  { key: 'waterEmission', name: '废水排放量', unit: 'm³' },
];
